import { render, staticRenderFns } from "./notifItem.vue?vue&type=template&id=dd196910&scoped=true&"
import script from "./notifItem.vue?vue&type=script&lang=js&"
export * from "./notifItem.vue?vue&type=script&lang=js&"
import style0 from "./notifItem.vue?vue&type=style&index=0&id=dd196910&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd196910",
  null
  
)

export default component.exports